import React from 'react';

const CATEGORY_STYLES = {
  Service:       { bg: 'rgba(59, 130, 246, 0.10)', color: '#5B9BF7', border: 'rgba(59, 130, 246, 0.20)' },
  Product:       { bg: 'rgba(168, 85, 247, 0.10)', color: '#B78AF7', border: 'rgba(168, 85, 247, 0.20)' },
  Operations:    { bg: 'rgba(234, 179, 8, 0.10)', color: '#E5C040', border: 'rgba(234, 179, 8, 0.20)' },
  AI:            { bg: 'rgba(6, 182, 212, 0.10)', color: '#3DD4E8', border: 'rgba(6, 182, 212, 0.20)' },
  Noncompliance: { bg: 'rgba(148, 163, 184, 0.08)', color: '#8890A0', border: 'rgba(148, 163, 184, 0.15)' },
};

const DEFAULT = { bg: 'rgba(148, 163, 184, 0.08)', color: '#8890A0', border: 'rgba(148, 163, 184, 0.15)' };

export default function CategoryBadge({ category }) {
  if (!category) return null;
  const s = CATEGORY_STYLES[category] || DEFAULT;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 8px', borderRadius: '6px',
      fontSize: '9px', fontWeight: 700,
      textTransform: 'uppercase', letterSpacing: '0.1em',
      background: s.bg, color: s.color,
      borderLeft: `2px solid ${s.color}`,
    }}>
      {category}
    </span>
  );
}
